import { render } from "./RestaurantStatusBanner.vue?vue&type=template&id=f6828550&ts=true"
import script from "./RestaurantStatusBanner.vue?vue&type=script&lang=ts"
export * from "./RestaurantStatusBanner.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__